import styled from "styled-components";

const Button = styled.button`
  margin: 0;
  padding: 0;

  background-color: transparent;
  outline: none;
  border: none;
`;

export default Button;



// WEBPACK FOOTER //
// ./src/ui/Button.js